import { Box, Flex, Heading, Text, Icon } from "@chakra-ui/react";
import { Chart } from "react-google-charts";
import { BsCircleFill } from "react-icons/bs";

interface Item {
  skill: string;
  percentage: number;
  color: string;
  technologies: Array<string>;
}

const Skills = (): JSX.Element => {
  const data: Array<Item> = [
    {
      skill: "Frontend",
      percentage: 60,
      color: "#17BBA6",
      technologies: ["React", "Angular", "Vue"],
    },
    {
      skill: "Backend",
      percentage: 10,
      color: "#38bdf8",
      technologies: ["Node", "Express", "Nest", "Laravel"],
    },
    {
      skill: "Database",
      percentage: 10,
      color: "#F50057",
      technologies: ["MySQL", "DynamoDB", "Firebase"],
    },
    {
      skill: "Infrastructure",
      percentage: 10,
      color: "#f59e0b",
      technologies: ["AWS", "Cloudflare", "GitHub", "Bitbucket"],
    },
    {
      skill: "Management",
      percentage: 10,
      color: "#6c63ff",
      technologies: ["Jira", "Trello", "Confluence"],
    },
  ];

  const getChartData = (data: Array<Item>): Array<Array<string | number>> => {
    return [
      ["Skill", "percentage"],
      ...data.map((item: Item) => [item.skill, item.percentage]),
    ];
  };

  return (
    <Box width={"full"} textAlign={"center"}>
      <Heading size={"lg"}>Where I came from</Heading>

      <Flex
        marginTop={6}
        wrap={"wrap"}
        justifyContent={"space-around"}
        alignItems={"center"}
      >
        <Box textAlign={"center"}>
          {data.map((item) => (
            <Text key={item.skill.toLowerCase()}>
              {item.technologies.join(", ")}
            </Text>
          ))}
        </Box>

        <Flex wrap={"wrap"} justifyContent={"center"} alignItems={"center"}>
          <Chart
            chartType={"PieChart"}
            data={getChartData(data)}
            width={"300px"}
            height={"300px"}
            options={{
              legend: "none",
              pieHole: 0.4,
              backgroundColor: "transparent",
              fontSize: 16,
              pieSliceText: "percentage",
              colors: data.map((item) => item.color),
            }}
          />

          <Box>
            {data.map((item) => (
              <Flex
                key={item.skill.toLowerCase()}
                gap={1}
                alignItems={"center"}
              >
                <Icon as={BsCircleFill} color={item.color} />
                <Text>{item.skill}</Text>
              </Flex>
            ))}
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Skills;
